module.exports = __webpack_public_path__ + "img/2.67c3de9f.jpg";